import MontserratRegularFont from "assets/fonts/Montserrat-Regular.ttf";
import MontserratSemiBoldFont from "assets/fonts/Montserrat-SemiBold.ttf";
import MontserratBoldFont from "assets/fonts/Montserrat-Bold.ttf";

export const Montserrat = {
  fontFamily: "Montserrat",
  fontWeight: 400,
  src: `
    local('Montserrat'),
    local('Montserrat-Regular'),
    url(${MontserratRegularFont}) format('woff2')
  `,
};

export const MontserratSemiBold = {
  fontFamily: "Montserrat",
  fontWeight: 600,
  src: `
    local('Montserrat'),
    local('Montserrat-Semi-Bold'),
    url(${MontserratSemiBoldFont}) format('woff2')
  `,
};

export const MontserratBold = {
  fontFamily: "Montserrat",
  fontWeight: 700,
  src: `
    local('Montserrat'),
    local('Montserrat-Bold'),
    url(${MontserratBoldFont}) format('woff2')
  `,
};
